import React from 'react';
import './StatsSection.css';
import { FaDatabase, FaFlag, FaMapMarkedAlt, FaWater } from 'react-icons/fa';
import { MdPublic } from 'react-icons/md';

const stats = [
  {
    number: '44',
    label: 'National water accounts',
    icon: <FaFlag style={{ color: '#28a745' }} />,
  },
  {
    number: '30+',
    label: 'Water data<br>products', // line break
    icon: <FaDatabase style={{ color: '#0077b6' }} />,
  },
  {
    number: '10',
    label: 'River basin assessments',
    icon: <FaWater style={{ color: '#17a2b8' }} />,
  },
  {
    number: '5',
    label: 'Regional water accounts',
    icon: <FaMapMarkedAlt style={{ color: '#fd7e14' }} />,
  },
  {
    number: '1',
    label: 'Continental water accounts',
    icon: <MdPublic style={{ color: '#6f42c1' }} />,
  },
];

const StatsSection = () => {
  return (
    <div className="stats-container">
      <h2 className="stats-title">DIWASA is providing water data for Africa</h2>

      <div className="stats-grid">
        {stats.map((stat, index) => {
          const isProducts = stat.label === 'Water data<br>products';
          return (
            <div className={`stat-box ${isProducts ? 'is-products' : ''}`} key={index}>
              <div className="stat-label-row">
                <div className="stat-icon">{stat.icon}</div>

                {/* Render label as HTML so <br> works */}
                <div
                  className="stat-label"
                  dangerouslySetInnerHTML={{ __html: stat.label }}
                />
              </div>

              <div className="stat-number">{stat.number}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default StatsSection;
